import React, { useState, useEffect } from 'react';
import "./style.scss";
import { imageBaseUrl } from "../utils/variables";
export var TYPE;
(function (TYPE) {
    TYPE["SUCCESS"] = "SUCCESS";
    TYPE["WARNING"] = "WARNING";
    TYPE["DANGER"] = "DANGER";
})(TYPE || (TYPE = {}));
var Snackbar = function (props) {
    var _a = useState(props.show), show = _a[0], setShow = _a[1];
    useEffect(function () {
        show && setTimeout(function () {
            setShow(!show);
            props.onCloseHandler(!show);
        }, props.timeout ? props.timeout : 2600);
    }, [show]);
    useEffect(function () {
        setShow(props.show);
    }, [props.show]);
    var style = {
        backgroundColor: props.color ? props.color : "",
        color: props.textColor ? props.textColor : "",
        height: props.height ? props.height : "",
        width: props.width ? props.width : "",
    };
    return (React.createElement("div", { className: "snack-bar-wraper" }, show && React.createElement("div", { className: "snack-bar".concat(props.type ? " ".concat(props.type.toLowerCase()) : ""), style: style, onClick: function () { return props.onCloseHandler(show); } },
        props.icon && React.createElement("img", { src: "".concat(imageBaseUrl, "/").concat(props.icon), alt: "snack-icon", width: "30px" }),
        props.children)));
};
export default Snackbar;
//# sourceMappingURL=index.js.map